export const Show = ({ when, children }: { when: boolean, children }) => when ? children : null
